import React, { useState } from 'react';
import { Container, Row, Col, Nav, Table } from 'react-bootstrap';
import './ProductDetails.css'
import img1 from '../Components/Images/applications/i9hrs1.jpg'
import img2 from '../Components/Images/applications/i9hrs2.jpg'
import img3 from '../Components/Images/applications/i9hrs3.jpg'
import img4 from '../Components/Images/applications/i9hrs4.jpg'
import img5 from '../Components/Images/applications/i9hrs5.jpg'
import img6 from '../Components/Images/applications/i9hrs6.jpg'

function I9hrs() {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState('specifications');
 

  // Specification data for the table
  const specificationData = [
    
        { label: 'Model', value: 'LEAD TECH i9 HRS Inkjet Printer' },
        { label: 'Material', value: 'Stainless steel + Precision coating' },
        { 
          label: 'Printing Performance', 
          value: '1-4 Lines(7X5 matrix)\n1-5 Lines(5X5 matrix)\nMax. speed=430m/min@5X5' 
        },
        { 
          label: 'Font Matrix', 
          value: 'Single-Line:5X5,7X5,9x6,12X8,16X11,19X14,24X17,32X22\n3 Lines:5X5,7X5,9x6\n5 Lines:5X5\nTwin-Line:5X5,7X5,9x6,12X8,16X11\n4 Lines:5X5,7X5' 
        },
        { 
          label: 'Printing Distance', 
          value: 'Font Height:1-15mm\nPrinting distance:2mm to 30mm\nBest:10mm' 
        },
        { 
          label: 'Operating System', 
          value: 'LT-Touch unique System, Multiple Languages' 
        },
        { 
          label: 'Print Content', 
          value: 'English, Chinese, Arabic Numbers, serial number, Bar code, Shift, DM/QR Code, UPC A&E, G51, logo, EAN 8 & 13, UCC/EAN 128, Code 128 A, B & C, Code 39, Code 125, automatic date/time/expiry date, special characters, etc.' 
        },
        { 
          label: 'Extra Memory', 
          value: 'USB, RS485, RS232, BCD, Ethernet' 
        },
        { 
          label: 'System Language', 
          value: 'Chinese, English, Korean, Russian, Polish, Persian, Arabic, Spanish, German, Indonesian, Vietnamese, Croatian, Thai, Slovenian, Slovak, Bosnian, Portuguese, Italian, etc. Customizable language' 
        },
        { 
          label: 'Memory Storage', 
          value: '1000+ Messages' 
        },
        { 
          label: 'Industrial Protection', 
          value: 'IP55, IP65 (Option)' 
        },
        { 
          label: 'Printhead', 
          value: 'Super soft, length 3m constant temperature, 50μm' 
        },
        { 
          label: 'Printing Direction', 
          value: '360° All-round printing' 
        },
        { 
          label: 'Cartridge Volume', 
          value: 'Ink (750ml), Make-up (750ml)' 
        },
        { 
          label: 'Temperature/Humidity range', 
          value: '0-50°C, 0-95% Relative Humidity (Non-condensing)' 
        },
        { 
          label: 'Power', 
          value: '100-120/200-240V~, 50-60Hz, 1.1-0.55A, 120W' 
        }
      ];
    
 
  const applications1 = [
    {
      id: 1,
      image:img1,
      name: "Plastic",
      
    },
    {
      id: 2,
      image:img2,
      name: "Wood",
      
    },
    {
      id: 3,
      image:img3,
      name: "Bottle",
      
    },
    {
      id: 4,
      image:img4,
      name: "Steel",
      
    },
    {
      id: 5,
      image:img5,
      name: "Steel",
      
    },
    {
      id: 6,
      image:img6,
      name: "Wood",
      
    }
    
  ];

  // Sample data for other tabs (replace with your actual content)
  const featuresContent = (
    <div style={{paddingLeft:"20px", paddingTop:"10px", paddingBottom:"10px"}}>
      <h4 style={{marginTop:"10px"}}>Key Features</h4>
      
  <p className='fw-bold'>Friendly User Interface</p>
  <p style={{fontFamily:"times"}}>
    10.4 inch Touch Screen<br/>
    Quick Startup (57 seconds)<br/>
    One Button Turn ON/OFF<br/>
    Multiple Language Interface<br/>
  </p>

  <p className='fw-bold'>IoT Industry 4.0</p>
  <p style={{fontFamily:"times"}}>
    RS485, USB & Ethernet Connections<br/>
    Support Data Matrix & QR Code Printing<br/>
    Remote Upgrade of Software & Firmware<br/>
  </p>

  <p className='fw-bold'>New Generation Printhead</p>
  <p style={{fontFamily:"times"}}>
    Innovative Printhead with Twin-valves<br/>
    Injection Molding Technology to Prevent Ink Leakage<br/>
    Auto-cleaning to Ensure Longer Uptime<br/>
  </p>

  <p className='fw-bold'>Stable Ink System</p>
  <p style={{fontFamily:"times"}}>
    Auto Filling Startup<br/>
    More Stable Pressure<br/>
    Durable InkCore Design, Easy to Replace<br/>
    Auto Modulation Function without Manual Adjustment<br/>
  </p>
    </div>
  );
  const applicationsContent = (
    <div style={{marginLeft:"10px", marginRight:"10px"}} className='pt-5'>
      <h2 className="text-center mb-4 " style={{fontSize:"25px", fontFamily:"sans-serif"}}>Our Applications</h2>
      
      <div className="row g-4">
        {applications1.map((app) => (
          <div key={app.id} className="col-md-6 col-lg-4 pb-5">
            <div className="card h-100 app-card shadow-sm">
              <img 
                src={app.image} 
                className="card-img-top" 
                alt={app.name}
                style={{ height: '200px', objectFit: 'cover' }}
              />
              <div className="card-body">
                <h5 className="card-title text-center" style={{fontSize:"15px"}}>{app.name}</h5>
               
              </div>
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const brochuresContent = (
    <div>
      <h4>Available Brochures</h4>
      <ul>
        <li><a href="#">LT860 Product Brochure (PDF, 2.4MB)</a></li>
        <li><a href="#">Technical Specifications Sheet (PDF, 1.1MB)</a></li>
        <li><a href="#">User Manual (PDF, 5.7MB)</a></li>
      </ul>
    </div>
  );

  const comparisonContent = (
    <div>
      <h4>Product Comparison</h4>
      <p>Compare the LT860 with other models in our product line:</p>
      <Table striped bordered>
        <thead>
          <tr>
            <th>Feature</th>
            <th>LT860</th>
            <th>LT850</th>
            <th>LT900</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Max Speed</td>
            <td>287m/min</td>
            <td>250m/min</td>
            <td>320m/min</td>
          </tr>
          <tr>
            <td>Lines</td>
            <td>Up to 5</td>
            <td>Up to 3</td>
            <td>Up to 6</td>
          </tr>
          <tr>
            <td>Protection</td>
            <td>IP55</td>
            <td>IP54</td>
            <td>IP56</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );

  // Render different content based on active tab
  // const renderTabContent = () => {
  //   switch (activeTab) {
  //     case 'specifications':
  //       return (
  //         <Table bordered hover className="mb-0">
  //           <tbody>
  //             {specificationData.map((item, index) => (
  //               <tr key={index}>
  //                 <td className="bg-light" style={{ width: '20%' }}>{item.label}</td>
  //                 <td style={{ whiteSpace: 'pre-line' }}>{item.value}</td>
  //               </tr>
  //             ))}
  //           </tbody>
  //         </Table>
  //       );
  //     case 'features':
  //       return featuresContent;
  //     case 'applications':
  //       return applicationsContent;
  //     case 'brochures':
  //       return brochuresContent;
  //     case 'comparison':
  //       return comparisonContent;
  //     default:
  //       return null;
  //   }
  // };

  const renderTabContent = () => {
    let content;
    
    switch (activeTab) {
      case 'specifications':
        content = (
          <Table bordered hover className="mb-0">
            <tbody>
              {specificationData.map((item, index) => (
                <tr key={index}>
                  <td className="bg-light" style={{ width: '20%' }}>{item.label}</td>
                  <td style={{ whiteSpace: 'pre-line' }}>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        );
        break;
      case 'features':
        content = featuresContent;
        break;
      case 'applications':
        content = applicationsContent;
        break;
      default:
        content = null;
    }
    
    return <div className="tab-content-animation">{content}</div>;
  };

  return (
    <Container fluid className="mt-4">
      
      <Row>
        {/* Left sidebar */}
        <Col md={3}>
          <div className="bg-light p-3 rounded">
            <h5 className="mb-3">Products</h5>
            
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <input type="checkbox" id="continuousInkjet" className="me-2" checked />
                <label htmlFor="continuousInkjet" className="mb-0 fw-bold">Continuous Inkjet Printer</label>
              </div>
              
              <div className="ms-4">
                <div className="mb-2">i9 Series</div>
                <div className="mb-2">LT900 Series</div>
                <div className="mb-2">LT800 Series</div>
              </div>
            </div>
            
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <input type="checkbox" id="laserMarking" className="me-2" />
                <label htmlFor="laserMarking" className="mb-0 fw-bold">Laser Marking Machine</label>
              </div>
            </div>
            
            <div>
              <div className="d-flex align-items-center mb-2">
                <label className="mb-0 fw-bold">Piezo Inkjet Printer</label>
              </div>
            </div>
          </div>
          
          <div className="bg-light p-3 rounded mt-4">
            <h5 className="mb-3">Send your inquiry</h5>
            <form>
              <div className="mb-3">
                <input type="text" className="form-control" placeholder="* Name" required />
              </div>
              <div className="mb-3">
                <input type="email" className="form-control" placeholder="* Email" required />
              </div>
              <div className="mb-3">
                <input type="text" className="form-control" placeholder="* Phone/WhatsApp(+Area Code)" required />
              </div>
              <div className="mb-3">
                <input type="text" className="form-control" placeholder="Company Name" />
              </div>
              <div className="mb-3">
                <textarea className="form-control" rows="5" placeholder="* Content" required></textarea>
              </div>
              <button type="submit" className="btn btn-primary">Submit</button>
            </form>
          </div>
        </Col>
        
        {/* Main content area */}
        {/* <Col md={9}>
         
          <Nav className="nav-tabs-custom">
            <Nav.Item>
              <Nav.Link 
                className={`px-4 py-3 ${activeTab === 'specifications' ? 'active bg-danger text-white' : 'bg-light'}`}
                onClick={() => setActiveTab('specifications')}
              >
                Specifications
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                className={`px-4 py-3 ${activeTab === 'features' ? 'active bg-danger text-white' : 'bg-light'}`}
                onClick={() => setActiveTab('features')}
              >
                Features
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                className={`px-4 py-3 ${activeTab === 'applications' ? 'active bg-primary text-white' : 'bg-light'}`}
                onClick={() => setActiveTab('applications')}
              >
                Applications
              </Nav.Link>
            </Nav.Item>
            
          </Nav>
          
          
          <div className="border border-top-0 p-0">
            {renderTabContent()}
          </div>
        </Col> */}
        {/* Updated Nav component for your ProductDetails.jsx */}
        <Col md={9}>
<div className="product-navbar-container mb-4">
  <Nav className="nav-tabs-custom d-flex justify-content-center">
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'specifications' ? 'active' : ''}`}
        onClick={() => setActiveTab('specifications')}
      >
        <span className="nav-text">Specifications</span>
      </Nav.Link>
    </Nav.Item>
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'features' ? 'active' : ''}`}
        onClick={() => setActiveTab('features')}
      >
        <span className="nav-text">Features</span>
      </Nav.Link>
    </Nav.Item>
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'applications' ? 'active' : ''}`}
        onClick={() => setActiveTab('applications')}
      >
        <span className="nav-text">Applications</span>
      </Nav.Link>
    </Nav.Item>
  </Nav>
</div>
<div className="border border-top-0 p-0 bg-white">
  {renderTabContent()}
</div>
</Col>
      </Row>
    </Container>
  );
}

export default I9hrs;